import React from "react";

export function MoneyIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={53}
            height={53}
            viewBox="0 0 53 53"
            {...props}
        >
            <g
                id="Groupe_35793"
                data-name="Groupe 35793"
                transform="translate(-0.5)"
            >
                <g
                    id="Groupe_8424"
                    data-name="Groupe 8424"
                    transform="translate(0.5 0)"
                >
                    <circle
                        id="Ellipse_197"
                        data-name="Ellipse 197"
                        cx={26.5}
                        cy={26.5}
                        r={26.5}
                        fill="var(--global-color)"
                    />
                </g>
                <g
                    id="argent_1_"
                    data-name="argent (1)"
                    transform="translate(1.998 1.5)"
                >
                    <path
                        id="Trac\xE9_22969"
                        data-name="Trac\xE9 22969"
                        d="M16.819,165.289a26.231,26.231,0,0,1-7.975,6.022,2.262,2.262,0,0,0-1.122,3.039"
                        transform="translate(0 -147.245)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22970"
                        data-name="Trac\xE9 22970"
                        d="M190.139,20.639l.155-.07a2.264,2.264,0,0,0,.915-3.389L185.5,9.221a4.12,4.12,0,0,0-5.176-1.292c-3.934,1.95-6.9,5.252-9.921,8.471"
                        transform="translate(-152.013 0)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22971"
                        data-name="Trac\xE9 22971"
                        d="M128.681,83.2c.11-.668-.247-1.028-.664-1.609a1.37,1.37,0,0,0-1.5-.507,4.323,4.323,0,0,1-4.043-.92,1.174,1.174,0,0,0-1.514-.049,52.422,52.422,0,0,0-5.358,5.215c-6.267,6.69-6.31,5.641-6.734,6.62"
                        transform="translate(-94.594 -67.53)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22972"
                        data-name="Trac\xE9 22972"
                        d="M23.027,151.662a24.113,24.113,0,0,1-6.75,2.426,4.121,4.121,0,0,1-4.605-2.694l-3.248-9.243a2.263,2.263,0,0,1,1.83-3c8.512-1.136,14.824-8.535,23.212-10.025a4.121,4.121,0,0,1,4.605,2.694l3.247,9.243a2.263,2.263,0,0,1-1.558,2.942"
                        transform="translate(-0.739 -113.444)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22973"
                        data-name="Trac\xE9 22973"
                        d="M267.966,190a36.268,36.268,0,0,1,4.347-2.306,1.091,1.091,0,0,1,1.37.474,4.082,4.082,0,0,0,3.449,2.021,1.312,1.312,0,0,1,1.232.908l.231.688a1.383,1.383,0,0,1-.452,1.542A4.717,4.717,0,0,0,276.6,196.1"
                        transform="translate(-243.059 -168.076)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22974"
                        data-name="Trac\xE9 22974"
                        d="M92.211,253.893c-.578.3-1.157.587-1.741.843a1.615,1.615,0,0,1-1.79-.355,3.772,3.772,0,0,0-3.037-1.189.921.921,0,0,1-.97-.637l-.621-1.851a.988.988,0,0,1,.344-1.11,4.344,4.344,0,0,0,1.706-3.1,1.567,1.567,0,0,1,.937-1.288,51.424,51.424,0,0,0,7.319-4"
                        transform="translate(-71.387 -218.084)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22975"
                        data-name="Trac\xE9 22975"
                        d="M205.508,285.24a2.072,2.072,0,0,1-.846-.867c-.649-1.258.065-2.991,1.594-3.87s3.294-.573,3.943.685a2.216,2.216,0,0,1,.237,1.109"
                        transform="translate(-183.761 -254.291)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22976"
                        data-name="Trac\xE9 22976"
                        d="M362.962,336.721h0l1.437,1.262c2.135,2.081,1.908,5.674-.505,8.026-2.311,2.251-5.788,2.55-7.954.748"
                        transform="translate(-325.154 -307.221)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22977"
                        data-name="Trac\xE9 22977"
                        d="M351.16,315.328c3.521-2.549,8.128-.944,8.667,3.077.574,4.293-3.838,8.191-7.96,6.954"
                        transform="translate(-320.693 -286.11)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22978"
                        data-name="Trac\xE9 22978"
                        d="M243.357,336.711h0l1.438,1.263c2.135,2.081,1.908,5.674-.506,8.026s-6.1,2.573-8.237.492l-.733-.714"
                        transform="translate(-212.594 -307.212)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                    <path
                        id="Trac\xE9_22979"
                        data-name="Trac\xE9 22979"
                        d="M213.806,323.668c2.632-2.632,2.573-6.71-.112-8.624h0a5.9,5.9,0,0,0-7.5,1.012c-2.377,2.377-2.659,6.132-.343,8.253v0C207.938,326.222,211.464,326.011,213.806,323.668Z"
                        transform="translate(-183.607 -286.129)"
                        fill="none"
                        stroke="var(--secondary-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                    />
                </g>
            </g>
        </svg>
    );
}
